import React from 'react';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import { presets, prepareURL } from '../../../../components/Postback/GlobalPostbackPresets';
import { FMessage } from '../../../../hoc/IntlComponents';

export default class GlobalPostbackPresets extends React.Component {
  state = {
    selectedPreset: null,
  };
  changePreset = selectedPreset =>
    this.setState(
      () => ({ selectedPreset }),
      () => {
        this.props.onPresetApply(prepareURL(selectedPreset.value));
      },
    );

  render() {
    const { selectedPreset } = this.state;
    return (
      <FormGroup className="postback-presets">
        <Select
          className="Select--sm"
          id="language"
          name="language"
          clearable={false}
          value={selectedPreset}
          onChange={option => this.changePreset(option)}
          options={presets.map(({ id, title, params }) => ({
            value: { id, params },
            label: title,
          }))}
          placeholder={<FMessage id="postback.preset.placeholder" />}
        ></Select>
      </FormGroup>
    );
  }
}
